import { render, staticRenderFns } from "./GiftVariants.vue?vue&type=template&id=1b02931f&lang=pug"
import script from "./GiftVariants.vue?vue&type=script&lang=js"
export * from "./GiftVariants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports